// extracted by mini-css-extract-plugin
export var chip = "_d6-0";
export var filterDropdown = "_d6-5";
export var filterItem = "_d6-6";
export var icon = "_d6-1";
export var removeButton = "_d6-3";
export var removeIcon = "_d6-4";
export var separator = "_d6-2";